import React from 'react';
import cx from 'classnames';

import Breadcrumbs from '@magoosh/layouts/components/breadcrumbs';
import Container from '@magoosh/layouts/components/container';
import LoadingIndicator from '@magoosh/layouts/components/loading_indicator';
import { BreadcrumbProps, SubnavProps } from '@magoosh/layouts/types';
import { BannerAlert, InfoAlert } from '@magoosh/lib/alerts';
import { FontAwesomeIcon } from '@magoosh/lib/icons';

import style from './style.module.scss';

interface Props {
  breadcrumbs?: BreadcrumbProps[];
  className?: string;
  linkComponent?: React.ComponentType<any>;
  loading?: boolean;
  notices?: {
    content: string;
    type: 'banner' | 'info';
  }[];
  style?: any;
  subnav?: SubnavProps;
}

const CardLayout: (React.FC<Props> & { Card: any }) = (props) => {
  const containerStyle = {} as any;
  return (
    <div className={cx(style.page, props.className)} style={props.style}>
      {props.subnav && (
        <div className={style.subnav}>
          <div className="align-items-sm-center container d-flex flex-column flex-sm-row gap-xs gap-sm-s">
            <div className={cx(style.subnavBackLink, 'align-items-center d-flex flex-1 gap-xs gap-sm-s')}>
              <FontAwesomeIcon icon="chevron-left" />

              {props.linkComponent ? (
                <props.linkComponent href={props.subnav.backLink.path}>
                  {props.subnav.backLink.name}
                </props.linkComponent>
              ) : (
                <a href={props.subnav.backLink.path}>
                  {props.subnav.backLink.name}
                </a>
              )}
            </div>

            <div className="d-flex justify-content-sm-center">
              <h4 className="u-margin-A-n">
                <strong>{props.subnav.title}</strong>
              </h4>
            </div>

            <div className="flex-1 hidden-xs" />
          </div>
        </div>
      )}

      <Container id="resizeable-container" className={props.subnav ? 'u-margin-T-m' : undefined}>
        {
          (props.notices || []).length > 0 && (
            <div className="d-flex flex-column gap-s u-margin-T-l">
              {
                props.notices.map((notice, idx) => {
                  let Alert = InfoAlert;

                  if (notice.type === 'banner') {
                    Alert = BannerAlert;
                  } else if (notice.type === 'info') {
                    Alert = InfoAlert;
                  }

                  return (
                    <Alert key={idx}>
                      <div dangerouslySetInnerHTML={{ __html: notice.content }} />
                    </Alert>
                  );
                })
              }
            </div>
          )
        }

        {
          props.breadcrumbs && (
            <Breadcrumbs breadcrumbs={props.breadcrumbs} linkComponent={props.linkComponent} />
          )
        }

        {
          props.loading ? (
            <div className="d-flex justify-content-center u-margin-T-l">
              <LoadingIndicator />
            </div>
          ) : typeof props.children === 'function' ? (props.children as any)({ loading: props.loading }) : props.children
        }
      </Container>
    </div>
  );
};

CardLayout.Card = (props) => {
  const content = (
    <div
      className={cx(
        style.pageCard,
        props.className,
        { [style.borderGradient]: props.borderGradient }
      )}
      style={props.style}
    >
      {props.children}
    </div>
  );

  if (props.borderGradient) {
    return (
      // Position relative and z-index are required for the gradientBorder to work properly
      <div style={{ position: 'relative', zIndex: 1 }}>
        {content}
      </div>
    );
  } else {
    return content;
  }
};

export default CardLayout;
